export function buildProjectPlansQueryV1(workspaceId: number, tchProjectId: number, projectId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectPlansQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ProjectId': projectId,
	}
}


export function buildProjectPlanByIdQueryV1(workspaceId: number, portfolioId: string, projectId: string, projectPlanId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectPlanByIdQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'PortfolioId': portfolioId,
		'ProjectId': projectId,
		'ProjectPlanId': projectPlanId
	}
}

export function buildProjectRevenuesQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectRevenuesQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ProjectId': projectId,
		'ProjectPlanId': projectPlanId
	}
}

export function buildProjectMarginsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectMarginsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ProjectId': projectId,
		'ProjectPlanId': projectPlanId
	}
}


export function buildProjectExpenseAllocationsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectExpenseAllocationsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ProjectId': projectId,
		'ProjectPlanId': projectPlanId
	}
}

export function buildProjectExpenseSavingsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectExpenseSavingsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ProjectId': projectId,
		'ProjectPlanId': projectPlanId
	}
}

export function buildProjectResourceAllocationsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectResourceAllocationsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ProjectId': projectId,
		'ProjectPlanId': projectPlanId
	}
}

export function buildProjectResourceSavingsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectResourceSavingsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ProjectId': projectId,
		'ProjectPlanId': projectPlanId
	}
}

export function buildProjectResourceUnitCostsQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectResourceUnitCostsQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ProjectId': projectId,
		'ProjectPlanId': projectPlanId
	}
}

export function buildProjectCapexQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectCapexQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ProjectId': projectId,
		'ProjectPlanId': projectPlanId
	}
}

export function buildProjectPlanPnlQueryV1(workspaceId: number, tchProjectId: number, projectId: string, projectPlanId: string, pnlId: string | null,
	applyBenefitsConfidenceFactor: boolean, denomination: string | null)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.ProjectPlanPnlQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
		'ProjectId': projectId,
		'ProjectPlanId': projectPlanId,
		'PnlId': pnlId,
		'ApplyBenefitsConfidenceFactor': applyBenefitsConfidenceFactor,
		'Denomination': denomination
	}
}

export function buildMyPortfolioProjectsPageQueryV1(workspaceId: number, tchProjectId: number)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.MyPortfolioProjectsPageQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'TchProjectId': tchProjectId,
	}
}

export function buildGridProjectByIdQueryV1(workspaceId: number, portfolioId: string, projectId: string)
{
	return {
		'$type': 'TCh.Domain.Quest.Projects.Queries.GridProjectByIdQueryV1, TCh.Domain.Quest',
		'WorkspaceId': workspaceId,
		'PortfolioId': portfolioId,
		'ProjectId': projectId
	}
}